import TablePagination from '@material-ui/core/TablePagination';

/** @deprecated */
export default TablePagination;
